import React, { useMemo, useState, useEffect } from "react"
import PropTypes from "prop-types"
import TableContainer from "../../components/Common/TableContainer"
import Swal from "sweetalert2";
import { Link } from "react-router-dom"
import { deleteproperty, deleteWebstory, getAllProperties, updateSequence, getWebstories } from "service/api";
import EditPropertyModal from "./EditPropertyModal";

function DatatableTables() {

  const [webstories, setWebstories] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);

  useEffect(() => {
    getAllwebstories()
  }, []);

  const getAllwebstories = async () => {
    let res = await getAllProperties();
    setWebstories(res.properties);
  }

  const handleEditClick = (property) => {
    setSelectedProperty(property);
    setIsEditModalOpen(true);
  };

  const handleSaveProperty = async (updatedProperty) => {
    try {
      toast.success("Property updated successfully");
      getAllwebstories(); // Refresh the data
      setIsEditModalOpen(false);
    } catch (error) {
      toast.error("Error updating property");
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Are you sure you want to delete this data?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteproperty(id);
          setWebstories(webstories.filter(site => site.id !== id));
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'property Delete successfully!',
          }).then(() => {
            getAllwebstories();
          });
        } catch (error) {
          console.error('Error deleting property:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Failed to delete property.',
          });
        }
      }
    }
    )
  };

  const handleSequenceChange = async (id, value) => {
    try {
      await updateSequence(id, value);
      const updatedWebstories = webstories.map((item) =>
        item.id === id ? { ...item, sequence: value } : item
      );
      setWebstories(updatedWebstories);

      Swal.fire({
        icon: "success",
        title: "Sequence Updated",
        text: `Sequence has been successfully updated to ${value}.`,
      });

      getAllwebstories();
    } catch (error) {
      if (error.response && error.response.status === 409) {
        Swal.fire({
          icon: "warning",
          title: "Duplicate Sequence",
          text: error.response.data.message || "This sequence is already in use. Please choose another.",
        });
      } else {
        console.error("Error updating sequence:", error);
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "There was an error updating the sequence.",
        });
      }
    }
  };




  const columns = useMemo(
    () => [
      {
        Header: "Sr.no",
        accessor: "srNo",
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: "Title",
        accessor: "title",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "Date",
        accessor: "created_at",
      },
      {
        Header: "Sequence",
        accessor: "sequence",
        Cell: ({ row }) => {
          const currentId = row.original.id;
          const currentSequence = row.original.sequence ?? ""; // Fallback to empty if null/undefined

          const usedSequences = webstories
            .filter(item => item.id !== currentId)
            .map(item => item.sequence);

          return (
            <select
              value={currentSequence}
              onChange={(e) =>
                handleSequenceChange(currentId, parseInt(e.target.value, 10))
              }
              className="form-control"
              style={{ width: "100px" }}
            >
              <option value="">Choose</option> {/* Default option */}

              {[...Array(20)].map((_, i) => {
                const value = i + 1;
                const isUsed = usedSequences.includes(value);
                return (
                  <option
                    key={value}
                    value={value}
                    disabled={isUsed}
                  >
                    {value}
                  </option>
                );
              })}
            </select>
          );
        }
      },
      {
        Header: "Actions",
        accessor: "id",
        Cell: ({ row }) => (
          <div style={{ display: "flex" }}>
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil font-size-15"></i>
            </button>
            <button
              type="button"
              className="btn btn-danger  ml-2"
              onClick={() => handleDelete(row.original.id)}
            >
              <i className="mdi mdi-trash-can font-size-15"></i>
            </button>
          </div>
        ),
      },
    ],
    []
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-1"></div>
        {webstories && (
          <TableContainer
            columns={columns}
            data={webstories}
            isGlobalFilter={true}
            isAddOptions={false}
            customPageSize={10}
            className="custom-header-css"
          />
        )}
        <EditPropertyModal
          isOpen={isEditModalOpen}
          toggle={() => setIsEditModalOpen(!isEditModalOpen)}
          property={selectedProperty}
          onSave={handleSaveProperty}
        />
      </div>
    </div>
  )
}

DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTables



